import { Capacitor } from '@capacitor/core';
// Prefer direct plugin import (Capacitor v5+)
// eslint-disable-next-line import/no-extraneous-dependencies
import { SafeArea } from 'capacitor-plugin-safe-area';
export function applySafeAreaCSSVariables() {
    try {
        const probe = document.createElement('div');
        probe.style.cssText = [
            'position:fixed',
            'visibility:hidden',
            'pointer-events:none',
            'inset:auto',
            'padding-top:env(safe-area-inset-top)',
            'padding-left:env(safe-area-inset-left)',
            'padding-right:env(safe-area-inset-right)',
            'padding-bottom:env(safe-area-inset-bottom)'
        ].join(';');
        document.body.appendChild(probe);
        const cs = window.getComputedStyle(probe);
        const top = parseFloat(cs.paddingTop) || 0;
        const left = parseFloat(cs.paddingLeft) || 0;
        const right = parseFloat(cs.paddingRight) || 0;
        let bottom = parseFloat(cs.paddingBottom) || 0;
        document.body.removeChild(probe);
        const root = document.documentElement.style;
        // Set short vars consumed by CSS fallbacks
        root.setProperty('--sat', `${top}px`);
        root.setProperty('--sal', `${left}px`);
        root.setProperty('--sar', `${right}px`);
        root.setProperty('--sab', `${bottom}px`);
        // Toggle helper classes on root for CSS targeting
        const html = document.documentElement;
        const hasTop = top > 0.5; // tolerate precision
        const hasLeft = left > 0.5;
        const hasRight = right > 0.5;
        const hasBottom = bottom > 0.5;
        const any = hasTop || hasLeft || hasRight || hasBottom;
        html.classList.toggle('has-safe-area', any);
        html.classList.toggle('has-safe-top', hasTop);
        html.classList.toggle('has-safe-bottom', hasBottom);
        // Prefer plugin insets on native platforms (Android nav gestures, cutouts)
        try {
            const platform = typeof Capacitor?.getPlatform === 'function' ? Capacitor.getPlatform() : Capacitor?.platform;
            if (platform === 'android' || platform === 'ios') {
                // For Android, use a modest baseline to avoid overlap with 3-button nav
                if (platform === 'android') {
                    document.documentElement.style.setProperty('--sab', `12px`);
                    const html2 = document.documentElement;
                    html2.classList.add('has-safe-bottom');
                    html2.classList.add('has-safe-area');
                }
                // SafeArea plugin returns { insets: { top, left, right, bottom } } or flat props depending on version
                SafeArea.getSafeAreaInsets()
                    .then((res) => {
                    const inset = res?.insets || res;
                    const b = Number(inset?.bottom || 0);
                    const l = Number(inset?.left || 0);
                    const r = Number(inset?.right || 0);
                    const t = Number(inset?.top || 0);
                    // Merge: take max of env() and plugin values; on Android keep a small baseline
                    let mergedBottom = Math.max(bottom, b);
                    if (platform === 'android') {
                        mergedBottom = 12;
                    }
                    document.documentElement.style.setProperty('--sab', `${mergedBottom}px`);
                    document.documentElement.style.setProperty('--sal', `${Math.max(left, l)}px`);
                    document.documentElement.style.setProperty('--sar', `${Math.max(right, r)}px`);
                    document.documentElement.style.setProperty('--sat', `${Math.max(top, t)}px`);
                    const html2 = document.documentElement;
                    if (mergedBottom > 0.5)
                        html2.classList.add('has-safe-bottom');
                    if (Math.max(top, t) > 0.5 || Math.max(left, l) > 0.5 || Math.max(right, r) > 0.5 || mergedBottom > 0.5) {
                        html2.classList.add('has-safe-area');
                    }
                })
                    .catch(() => { });
            }
        }
        catch { }
    }
    catch {
        // no-op
    }
}
export function installSafeAreaWatcher() {
    const update = () => applySafeAreaCSSVariables();
    update();
    try {
        window.addEventListener('orientationchange', update, { passive: true });
    }
    catch { }
    try {
        window.addEventListener('resize', update, { passive: true });
    }
    catch { }
    try {
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', update, { passive: true });
        }
    }
    catch { }
}
